import { Phone, MapPin, Clock, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/constants";

export default function Contact() {
  const mapsSrc = `https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.mapsQuery)}&output=embed`;
  return (
    <div data-testid="contact-page" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black text-center">Contact Us</h1>
      <p className="mt-4 text-xl text-gray-700 text-center">We're here daily 8 AM – 10 PM. Reach out any time.</p>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-5">
          <InfoBlock icon={Phone} title="Phone" testid="contact-phone">
            <a href={`tel:${BUSINESS.phoneRaw}`} className="text-2xl font-bold text-navy hover:text-gold">
              {BUSINESS.phone}
            </a>
          </InfoBlock>
          <InfoBlock icon={MapPin} title="Address" testid="contact-address">
            <p className="text-lg text-gray-900">{BUSINESS.address}</p>
            <p className="text-lg text-gray-900">{BUSINESS.city}</p>
          </InfoBlock>
          <InfoBlock icon={Clock} title="Hours" testid="contact-hours">
            <p className="text-lg text-gray-900">{BUSINESS.hours}</p>
          </InfoBlock>

          <div className="flex flex-col sm:flex-row gap-3 pt-3">
            <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary" data-testid="contact-call-btn">
              <Phone className="w-5 h-5" /> Call Now
            </a>
            <Link to="/consultation" className="btn-primary" data-testid="contact-consult-btn">
              <CalendarCheck className="w-5 h-5" /> Book Free Consultation
            </Link>
          </div>
        </div>

        <div className="rounded-lg overflow-hidden border border-slate-200 shadow-sm h-96 lg:h-auto">
          <iframe
            data-testid="contact-map"
            title="Office location"
            src={mapsSrc}
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}

function InfoBlock({ icon: Icon, title, children, testid }) {
  return (
    <div data-testid={testid} className="bg-white border border-slate-200 rounded-lg p-6 flex items-start gap-4 shadow-sm">
      <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center flex-shrink-0">
        <Icon className="w-6 h-6 text-gold" />
      </div>
      <div>
        <div className="font-heading text-xl font-semibold text-navy">{title}</div>
        <div className="mt-1">{children}</div>
      </div>
    </div>
  );
}
